import type { Category } from "@/types";

export const categories: Category[] = [
  {
    id: "social",
    name: "社交聊天",
    icon: "ri-chat-smile-2-line",
    description: "即时通讯、社交动态与职场协作类中文应用，覆盖日常聊天到办公协同的完整场景。",
    subcategories: ["即时通讯", "社交动态", "职场协作", "视频社交", "兴趣社区"],
  },
  {
    id: "tools",
    name: "实用工具",
    icon: "ri-tools-line",
    description: "系统优化、文件管理、输入法与日常小工具合集，让手机运行更流畅、操作更高效。",
    subcategories: ["系统优化", "文件管理", "输入法", "效率工具", "安全防护"],
  },
  {
    id: "games",
    name: "手机游戏",
    icon: "ri-gamepad-line",
    description: "热门手游与精品单机合集，涵盖竞技、角色扮演、策略和休闲益智等多种玩法。",
    subcategories: ["竞技对战", "角色扮演", "策略战争", "休闲益智", "模拟经营"],
  },
  {
    id: "life",
    name: "生活服务",
    icon: "ri-hand-heart-line",
    description: "出行、外卖、购物、旅行与本地生活服务应用，一部手机解决日常吃穿住行。",
    subcategories: ["出行导航", "美食外卖", "旅行住宿", "购物消费", "快递物流"],
  },
];